import { render, staticRenderFns } from "./PptAttrPanel.vue?vue&type=template&id=18de96f1&"
import script from "./PptAttrPanel.vue?vue&type=script&lang=js&"
export * from "./PptAttrPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18de96f1')) {
      api.createRecord('18de96f1', component.options)
    } else {
      api.reload('18de96f1', component.options)
    }
    module.hot.accept("./PptAttrPanel.vue?vue&type=template&id=18de96f1&", function () {
      api.rerender('18de96f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/PptAttrPanel.vue"
export default component.exports